import React, { useEffect } from "react";
import { Container, Row, Col } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import {
  FaChartLine,
  FaUsers,
  FaWallet,
  FaHandshake,
  FaThumbsUp,
  FaEye,
  FaPlusCircle,
  FaGraduationCap,
  FaCogs,
  FaUserCog,
  FaLaptop,
  FaBullseye,
  FaCreditCard,
} from "react-icons/fa";
import { getPerformanceDashBoard } from "../../../redux/modules/profile/profile.action";

import "./styles.scss";

const getColorByStatus = (status) => {
  if (status === "Aktif") return "#27ae60"; // yeşil
  if (status === "Pasif") return "#e74c3c"; // kırmızı
  return "#f1c40f"; // sarı
};

const LandingPage2 = () => {
  const dispatch = useDispatch();
  const performanceDashboard = useSelector(
    (state) => state.profile.performanceDashboard
  );

  useEffect(() => {
    const fetchPerformanceData = async () => {
      try {
        const result = await dispatch(getPerformanceDashBoard());
        console.log("getPerformanceDashBoard sonucu:", result);
      } catch (error) {
        console.error("getPerformanceDashBoard hatası:", error);
      }
    };

    fetchPerformanceData();
  }, [dispatch]);
  const getCardsFromPerformanceData = () => {
    if (!performanceDashboard) return [];

    const cardConfigs = [
      {
        key: "general",
        icon: <FaChartLine size={28} className="me-2" />,
        title: "Genel Performans",
        value: performanceDashboard.general ? "Aktif" : "Pasif",
        target: "Hedef",
        period: "Güncel Durum",
        info: performanceDashboard.general ? "Sistem aktif" : "Sistem pasif",
        infoType: performanceDashboard.general ? "success" : "danger",
        time: "Güncel",
      },
      {
        key: "sales",
        icon: <FaWallet size={28} className="me-2" />,
        title: "Satış Performansı",
        value: performanceDashboard.sales ? "Aktif" : "Pasif",
        target: "Hedef",
        period: "Güncel Durum",
        info: performanceDashboard.sales ? "Satış aktif" : "Satış pasif",
        infoType: performanceDashboard.sales ? "success" : "danger",
        time: "Güncel",
      },
      {
        key: "campaign",
        icon: <FaHandshake size={28} className="me-2" />,
        title: "Kampanya Performansı",
        value: performanceDashboard.campaign ? "Aktif" : "Pasif",
        target: "Hedef",
        period: "Güncel Durum",
        info: performanceDashboard.campaign
          ? "Kampanya aktif"
          : "Kampanya pasif",
        infoType: performanceDashboard.campaign ? "success" : "danger",
        time: "Güncel",
      },
      {
        key: "educationCertificate",
        icon: <FaGraduationCap size={28} className="me-2" />,
        title: "Eğitim Sertifikası",
        value: performanceDashboard.educationCertificate ? "Aktif" : "Pasif",
        target: "Hedef",
        period: "Güncel Durum",
        info: performanceDashboard.educationCertificate
          ? "Eğitim aktif"
          : "Eğitim pasif",
        infoType: performanceDashboard.educationCertificate
          ? "success"
          : "danger",
        time: "Güncel",
      },
      {
        key: "technicalPerformance",
        icon: <FaCogs size={28} className="me-2" />,
        title: "Teknik Performans",
        value: performanceDashboard.technicalPerformance ? "Aktif" : "Pasif",
        target: "Hedef",
        period: "Güncel Durum",
        info: performanceDashboard.technicalPerformance
          ? "Teknik aktif"
          : "Teknik pasif",
        infoType: performanceDashboard.technicalPerformance
          ? "success"
          : "danger",
        time: "Güncel",
      },
      {
        key: "customerManagement",
        icon: <FaUserCog size={28} className="me-2" />,
        title: "Müşteri Yönetimi",
        value: performanceDashboard.customerManagement ? "Aktif" : "Pasif",
        target: "Hedef",
        period: "Güncel Durum",
        info: performanceDashboard.customerManagement
          ? "Müşteri yönetimi aktif"
          : "Müşteri yönetimi pasif",
        infoType: performanceDashboard.customerManagement
          ? "success"
          : "danger",
        time: "Güncel",
      },
      {
        key: "digitalCompatibility",
        icon: <FaLaptop size={28} className="me-2" />,
        title: "Dijital Uyumluluk",
        value: performanceDashboard.digitalCompatibility ? "Aktif" : "Pasif",
        target: "Hedef",
        period: "Güncel Durum",
        info: performanceDashboard.digitalCompatibility
          ? "Dijital uyumlu"
          : "Dijital uyumsuz",
        infoType: performanceDashboard.digitalCompatibility
          ? "success"
          : "danger",
        time: "Güncel",
      },
      {
        key: "targetAchievement",
        icon: <FaBullseye size={28} className="me-2" />,
        title: "Hedef Başarımı",
        value: performanceDashboard.targetAchievement ? "Aktif" : "Pasif",
        target: "Hedef",
        period: "Güncel Durum",
        info: performanceDashboard.targetAchievement
          ? "Hedef başarıldı"
          : "Hedef başarılamadı",
        infoType: performanceDashboard.targetAchievement ? "success" : "danger",
        time: "Güncel",
      },
      {
        key: "payment",
        icon: <FaCreditCard size={28} className="me-2" />,
        title: "Ödeme Performansı",
        value: performanceDashboard.payment ? "Aktif" : "Pasif",
        target: "Hedef",
        period: "Güncel Durum",
        info: performanceDashboard.payment ? "Ödeme aktif" : "Ödeme pasif",
        infoType: performanceDashboard.payment ? "success" : "danger",
        time: "Güncel",
      },
    ];

    return cardConfigs.map((config) => ({
      ...config,
      status: config.infoType === "success" ? "Aktif" : "Pasif",
    }));
  };

  const cards = getCardsFromPerformanceData();

  return (
    <Container className="py-5">
      <h2 className="mb-sm-6 mb-4">Yönetim Paneli</h2>
      <p className="mb-sm-5 mb-4 fw-light"></p>
      <Row className="g-4">
        {cards.map((card, idx) => (
          <Col md={4} sm={6} xs={12} key={card.key}>
            <div className="border rounded shadow-sm p-3 bg-white h-100">
              <div className="d-flex align-items-center mb-2">
                {card.icon}
                <div>
                  <div className="text-muted small">{card.period}</div>
                  <div className="fw-bold">{card.title}</div>
                </div>
              </div>
              <div
                className="fw-bold display-7"
                style={{ color: getColorByStatus(card.status) }}
              >
                {card.status}
              </div>
              <div
                className="progress mb-2"
                style={{ height: 6, background: "#e9ecef" }}
              >
                <div
                  className="progress-bar"
                  style={{
                    width: `${card.status}%`,
                    background: getColorByStatus(card.status),
                  }}
                ></div>
              </div>
              <div className="d-flex justify-content-between small">
                <span style={{ color: getColorByStatus(card.status) }}>
                  {card.info}
                </span>
                <span className="text-muted">{card.time}</span>
              </div>
            </div>
          </Col>
        ))}
      </Row>
    </Container>
  );
};

export default LandingPage2;
